import React, { useState, useMemo, useCallback } from "react";
import { Helmet } from "react-helmet";
import Navbar from "components/Navbar";
import DashboardMenuBar from "components/DashboardMenuBar";

// ─────────────────────────────────────────────────────────────────────────────
// STATIC MOCK DATA  (replace with API fetch when backend is ready)
// ─────────────────────────────────────────────────────────────────────────────

const CLASS_INFO = {
  EQ: { label: "Equity",       color: "#2b36d9" },
  FI: { label: "Fixed Income", color: "#f59e0b" },
  CD: { label: "Commodity",    color: "#04ff1d" },
  MF: { label: "Alternative",  color: "#a084c9" },
  CS: { label: "Cash",         color: "#939393" },
};

const TYPE_INFO = {
  Buy:         { color: "#f59e0b", bg: "rgba(245,158,11,0.12)"  },
  Sell:        { color: "#04ff1d", bg: "rgba(4,255,29,0.08)"    },
  Dividend:    { color: "#06b6d4", bg: "rgba(6,182,212,0.10)"   },
  Coupon:      { color: "#06b6d4", bg: "rgba(6,182,212,0.10)"   },
  Transfer_In: { color: "#a084c9", bg: "rgba(160,132,201,0.12)" },
  Transfer_Out:{ color: "#fd527b", bg: "rgba(253,82,123,0.12)"  },
  Fee:         { color: "#939393", bg: "rgba(147,147,147,0.10)" },
};

const RAW = [
  // 2026
  { id:1,  date:"2026-03-28", ticker:"NVDA",  name:"NVIDIA Corp.",            ac:"EQ", type:"Sell",         qty:150,   price:875.20,  gross:131280,  net:131149.5, ccy:"USD", broker:"Interactive Brokers" },
  { id:2,  date:"2026-03-25", ticker:"TLT",   name:"iShares 20+ Yr Treasury", ac:"FI", type:"Buy",          qty:300,   price:96.40,   gross:28920,   net:28947.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:3,  date:"2026-03-20", ticker:"AAPL",  name:"Apple Inc.",              ac:"EQ", type:"Buy",          qty:50,    price:218.30,  gross:10915,   net:10929.5,  ccy:"USD", broker:"Fidelity"            },
  { id:4,  date:"2026-03-15", ticker:"GLD",   name:"SPDR Gold Shares",        ac:"CD", type:"Buy",          qty:200,   price:198.75,  gross:39750,   net:39784.5,  ccy:"USD", broker:"Fidelity"            },
  { id:5,  date:"2026-03-12", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Dividend",     qty:null,  price:null,    gross:1240,    net:1240,     ccy:"USD", broker:"Fidelity"            },
  { id:6,  date:"2026-03-10", ticker:"MSFT",  name:"Microsoft Corp.",         ac:"EQ", type:"Sell",         qty:30,    price:412.50,  gross:12375,   net:12357.8,  ccy:"USD", broker:"Interactive Brokers" },
  { id:7,  date:"2026-03-05", ticker:"CASH",  name:"Cash Deposit",            ac:"CS", type:"Transfer_In",  qty:null,  price:null,    gross:500000,  net:500000,   ccy:"USD", broker:"Fidelity"            },
  { id:8,  date:"2026-02-28", ticker:"HYG",   name:"iShares High Yield Corp", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:3820,    net:3820,     ccy:"USD", broker:"Interactive Brokers" },
  { id:9,  date:"2026-02-25", ticker:"AMZN",  name:"Amazon.com Inc.",         ac:"EQ", type:"Buy",          qty:40,    price:195.60,  gross:7824,    net:7835.7,   ccy:"USD", broker:"Fidelity"            },
  { id:10, date:"2026-02-20", ticker:"DBC",   name:"Invesco DB Commodity",    ac:"CD", type:"Sell",         qty:500,   price:24.30,   gross:12150,   net:12133.5,  ccy:"USD", broker:"Fidelity"            },
  { id:11, date:"2026-02-18", ticker:"REET",  name:"iShares Global REIT",     ac:"MF", type:"Dividend",     qty:null,  price:null,    gross:880,     net:880,      ccy:"USD", broker:"Interactive Brokers" },
  { id:12, date:"2026-02-14", ticker:"GOOGL", name:"Alphabet Inc.",           ac:"EQ", type:"Buy",          qty:25,    price:172.40,  gross:4310,    net:4317.2,   ccy:"USD", broker:"Fidelity"            },
  { id:13, date:"2026-02-10", ticker:"IB",    name:"Platform Fee",            ac:"CS", type:"Fee",          qty:null,  price:null,    gross:25,      net:25,       ccy:"USD", broker:"Interactive Brokers" },
  { id:14, date:"2026-02-05", ticker:"TLT",   name:"iShares 20+ Yr Treasury", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:2160,    net:2160,     ccy:"USD", broker:"Interactive Brokers" },
  { id:15, date:"2026-01-30", ticker:"NVDA",  name:"NVIDIA Corp.",            ac:"EQ", type:"Buy",          qty:100,   price:792.10,  gross:79210,   net:79325.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:16, date:"2026-01-28", ticker:"BRK.B", name:"Berkshire Hathaway B",    ac:"EQ", type:"Buy",          qty:120,   price:368.20,  gross:44184,   net:44248.7,  ccy:"USD", broker:"Fidelity"            },
  { id:17, date:"2026-01-22", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Buy",          qty:400,   price:108.90,  gross:43560,   net:43625.5,  ccy:"USD", broker:"Fidelity"            },
  { id:18, date:"2026-01-15", ticker:"QAI",   name:"IQ Hedge Multi-Strat",    ac:"MF", type:"Buy",          qty:600,   price:32.10,   gross:19260,   net:19292.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:19, date:"2026-01-10", ticker:"AAPL",  name:"Apple Inc.",              ac:"EQ", type:"Dividend",     qty:null,  price:null,    gross:460,     net:460,      ccy:"USD", broker:"Fidelity"            },
  { id:20, date:"2026-01-05", ticker:"CASH",  name:"Cash Withdrawal",         ac:"CS", type:"Transfer_Out", qty:null,  price:null,    gross:100000,  net:100000,   ccy:"USD", broker:"Fidelity"            },
  // 2025
  { id:21, date:"2025-12-30", ticker:"MSFT",  name:"Microsoft Corp.",         ac:"EQ", type:"Buy",          qty:45,    price:398.70,  gross:17941.5, net:17968.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:22, date:"2025-12-20", ticker:"HYG",   name:"iShares High Yield Corp", ac:"FI", type:"Buy",          qty:1000,  price:77.40,   gross:77400,   net:77512,    ccy:"USD", broker:"Interactive Brokers" },
  { id:23, date:"2025-12-15", ticker:"GLD",   name:"SPDR Gold Shares",        ac:"CD", type:"Sell",         qty:100,   price:186.30,  gross:18630,   net:18616.5,  ccy:"USD", broker:"Fidelity"            },
  { id:24, date:"2025-12-12", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Dividend",     qty:null,  price:null,    gross:1180,    net:1180,     ccy:"USD", broker:"Fidelity"            },
  { id:25, date:"2025-12-08", ticker:"IB",    name:"Platform Fee",            ac:"CS", type:"Fee",          qty:null,  price:null,    gross:25,      net:25,       ccy:"USD", broker:"Interactive Brokers" },
  { id:26, date:"2025-12-05", ticker:"AMZN",  name:"Amazon.com Inc.",         ac:"EQ", type:"Sell",         qty:60,    price:188.20,  gross:11292,   net:11279.7,  ccy:"USD", broker:"Fidelity"            },
  { id:27, date:"2025-11-28", ticker:"TLT",   name:"iShares 20+ Yr Treasury", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:2160,    net:2160,     ccy:"USD", broker:"Interactive Brokers" },
  { id:28, date:"2025-11-20", ticker:"REET",  name:"iShares Global REIT",     ac:"MF", type:"Buy",          qty:800,   price:22.60,   gross:18080,   net:18108.2,  ccy:"USD", broker:"Interactive Brokers" },
  { id:29, date:"2025-11-15", ticker:"GOOGL", name:"Alphabet Inc.",           ac:"EQ", type:"Buy",          qty:50,    price:165.80,  gross:8290,    net:8302.2,   ccy:"USD", broker:"Fidelity"            },
  { id:30, date:"2025-11-10", ticker:"DBC",   name:"Invesco DB Commodity",    ac:"CD", type:"Buy",          qty:1000,  price:23.10,   gross:23100,   net:23135,    ccy:"USD", broker:"Fidelity"            },
  { id:31, date:"2025-10-30", ticker:"AAPL",  name:"Apple Inc.",              ac:"EQ", type:"Sell",         qty:80,    price:228.40,  gross:18272,   net:18258.5,  ccy:"USD", broker:"Fidelity"            },
  { id:32, date:"2025-10-25", ticker:"HYG",   name:"iShares High Yield Corp", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:3740,    net:3740,     ccy:"USD", broker:"Interactive Brokers" },
  { id:33, date:"2025-10-20", ticker:"NVDA",  name:"NVIDIA Corp.",            ac:"EQ", type:"Buy",          qty:80,    price:136.50,  gross:10920,   net:10936.8,  ccy:"USD", broker:"Interactive Brokers" },
  { id:34, date:"2025-10-15", ticker:"CASH",  name:"Cash Deposit",            ac:"CS", type:"Transfer_In",  qty:null,  price:null,    gross:250000,  net:250000,   ccy:"USD", broker:"Fidelity"            },
  { id:35, date:"2025-10-10", ticker:"QAI",   name:"IQ Hedge Multi-Strat",    ac:"MF", type:"Sell",         qty:400,   price:31.80,   gross:12720,   net:12708.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:36, date:"2025-09-30", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Dividend",     qty:null,  price:null,    gross:1150,    net:1150,     ccy:"USD", broker:"Fidelity"            },
  { id:37, date:"2025-09-22", ticker:"MSFT",  name:"Microsoft Corp.",         ac:"EQ", type:"Buy",          qty:60,    price:376.90,  gross:22614,   net:22647.1,  ccy:"USD", broker:"Interactive Brokers" },
  { id:38, date:"2025-09-15", ticker:"BRK.B", name:"Berkshire Hathaway B",    ac:"EQ", type:"Sell",         qty:50,    price:352.40,  gross:17620,   net:17611.4,  ccy:"USD", broker:"Fidelity"            },
  { id:39, date:"2025-09-10", ticker:"GLD",   name:"SPDR Gold Shares",        ac:"CD", type:"Buy",          qty:150,   price:178.20,  gross:26730,   net:26768.6,  ccy:"USD", broker:"Fidelity"            },
  { id:40, date:"2025-09-05", ticker:"IB",    name:"Platform Fee",            ac:"CS", type:"Fee",          qty:null,  price:null,    gross:25,      net:25,       ccy:"USD", broker:"Interactive Brokers" },
  { id:41, date:"2025-08-28", ticker:"TLT",   name:"iShares 20+ Yr Treasury", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:2160,    net:2160,     ccy:"USD", broker:"Interactive Brokers" },
  { id:42, date:"2025-08-20", ticker:"AMZN",  name:"Amazon.com Inc.",         ac:"EQ", type:"Buy",          qty:75,    price:181.30,  gross:13597.5, net:13617.3,  ccy:"USD", broker:"Fidelity"            },
  { id:43, date:"2025-08-15", ticker:"REET",  name:"iShares Global REIT",     ac:"MF", type:"Dividend",     qty:null,  price:null,    gross:860,     net:860,      ccy:"USD", broker:"Interactive Brokers" },
  { id:44, date:"2025-08-10", ticker:"AAPL",  name:"Apple Inc.",              ac:"EQ", type:"Buy",          qty:100,   price:202.80,  gross:20280,   net:20309.6,  ccy:"USD", broker:"Fidelity"            },
  { id:45, date:"2025-07-31", ticker:"HYG",   name:"iShares High Yield Corp", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:3700,    net:3700,     ccy:"USD", broker:"Interactive Brokers" },
  { id:46, date:"2025-07-22", ticker:"NVDA",  name:"NVIDIA Corp.",            ac:"EQ", type:"Sell",         qty:120,   price:128.40,  gross:15408,   net:15397.1,  ccy:"USD", broker:"Interactive Brokers" },
  { id:47, date:"2025-07-15", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Dividend",     qty:null,  price:null,    gross:1120,    net:1120,     ccy:"USD", broker:"Fidelity"            },
  { id:48, date:"2025-07-08", ticker:"CASH",  name:"Cash Withdrawal",         ac:"CS", type:"Transfer_Out", qty:null,  price:null,    gross:50000,   net:50000,    ccy:"USD", broker:"Fidelity"            },
  { id:49, date:"2025-06-30", ticker:"GOOGL", name:"Alphabet Inc.",           ac:"EQ", type:"Sell",         qty:35,    price:159.60,  gross:5586,    net:5579.8,   ccy:"USD", broker:"Fidelity"            },
  { id:50, date:"2025-06-20", ticker:"DBC",   name:"Invesco DB Commodity",    ac:"CD", type:"Sell",         qty:600,   price:22.80,   gross:13680,   net:13672.5,  ccy:"USD", broker:"Fidelity"            },
  { id:51, date:"2025-06-15", ticker:"IB",    name:"Platform Fee",            ac:"CS", type:"Fee",          qty:null,  price:null,    gross:25,      net:25,       ccy:"USD", broker:"Interactive Brokers" },
  { id:52, date:"2025-06-10", ticker:"MSFT",  name:"Microsoft Corp.",         ac:"EQ", type:"Dividend",     qty:null,  price:null,    gross:560,     net:560,      ccy:"USD", broker:"Interactive Brokers" },
  { id:53, date:"2025-05-30", ticker:"TLT",   name:"iShares 20+ Yr Treasury", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:2160,    net:2160,     ccy:"USD", broker:"Interactive Brokers" },
  { id:54, date:"2025-05-22", ticker:"BRK.B", name:"Berkshire Hathaway B",    ac:"EQ", type:"Buy",          qty:100,   price:338.90,  gross:33890,   net:33939.5,  ccy:"USD", broker:"Fidelity"            },
  { id:55, date:"2025-05-15", ticker:"QAI",   name:"IQ Hedge Multi-Strat",    ac:"MF", type:"Buy",          qty:500,   price:30.90,   gross:15450,   net:15472.5,  ccy:"USD", broker:"Interactive Brokers" },
  { id:56, date:"2025-04-30", ticker:"LQD",   name:"iShares Corp Bond ETF",   ac:"FI", type:"Dividend",     qty:null,  price:null,    gross:1100,    net:1100,     ccy:"USD", broker:"Fidelity"            },
  { id:57, date:"2025-04-22", ticker:"AAPL",  name:"Apple Inc.",              ac:"EQ", type:"Buy",          qty:60,    price:194.50,  gross:11670,   net:11686.9,  ccy:"USD", broker:"Fidelity"            },
  { id:58, date:"2025-04-15", ticker:"HYG",   name:"iShares High Yield Corp", ac:"FI", type:"Coupon",       qty:null,  price:null,    gross:3660,    net:3660,     ccy:"USD", broker:"Interactive Brokers" },
  { id:59, date:"2025-04-08", ticker:"CASH",  name:"Cash Deposit",            ac:"CS", type:"Transfer_In",  qty:null,  price:null,    gross:300000,  net:300000,   ccy:"USD", broker:"Fidelity"            },
  { id:60, date:"2025-03-31", ticker:"REET",  name:"iShares Global REIT",     ac:"MF", type:"Dividend",     qty:null,  price:null,    gross:840,     net:840,      ccy:"USD", broker:"Interactive Brokers" },
];

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function fmtDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${MONTHS[+m-1]} ${+d}, ${y}`;
}

function fmtNum(n, decimals = 2) {
  if (n == null) return "—";
  return n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

function fmtMoney(n) {
  if (n == null) return "—";
  return "$" + fmtNum(n, 2);
}

function exportCSV(rows) {
  const cols = ["Date","Ticker","Name","Asset Class","Type","Quantity","Price","Gross Value","Net Value","Currency","Broker"];
  const lines = [cols.join(","), ...rows.map(r => [
    r.date, r.ticker, `"${r.name}"`,
    CLASS_INFO[r.ac]?.label ?? r.ac,
    r.type.replace("_"," "),
    r.qty ?? "", r.price ?? "",
    r.gross, r.net, r.ccy, `"${r.broker}"`
  ].join(","))];
  const url = URL.createObjectURL(new Blob([lines.join("\n")], { type:"text/csv" }));
  Object.assign(document.createElement("a"), { href:url, download:"transactions.csv" }).click();
  URL.revokeObjectURL(url);
}

// Date range preset helpers
function isoToday() { return new Date().toISOString().split("T")[0]; }
function isoOffset(days) {
  const d = new Date(); d.setDate(d.getDate() - days);
  return d.toISOString().split("T")[0];
}
function isoYearStart() { return `${new Date().getFullYear()}-01-01`; }
function isoOffset1Y()  { const d = new Date(); d.setFullYear(d.getFullYear()-1); return d.toISOString().split("T")[0]; }

const PRESETS = [
  { label:"1W",  from: isoOffset(7),    to: isoToday() },
  { label:"1M",  from: isoOffset(30),   to: isoToday() },
  { label:"3M",  from: isoOffset(90),   to: isoToday() },
  { label:"YTD", from: isoYearStart(),  to: isoToday() },
  { label:"1Y",  from: isoOffset1Y(),   to: isoToday() },
  { label:"All", from: "2000-01-01",    to: isoToday() },
];

const ALL_TYPES   = ["Buy","Sell","Dividend","Coupon","Transfer_In","Transfer_Out","Fee"];
const ALL_CLASSES = ["EQ","FI","CD","MF","CS"];
const ALL_BROKERS = [...new Set(RAW.map(r => r.broker))];

const PAGE_SIZE = 20;

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

export default function Transactions() {
  // ── Filter state ──────────────────────────────────────────────────────────
  const [dateFrom,    setDateFrom]    = useState("2000-01-01");
  const [dateTo,      setDateTo]      = useState(isoToday());
  const [activePreset,setActivePreset]= useState("All");
  const [selTypes,    setSelTypes]    = useState(new Set(ALL_TYPES));
  const [selClasses,  setSelClasses]  = useState(new Set(ALL_CLASSES));
  const [selBrokers,  setSelBrokers]  = useState(new Set(ALL_BROKERS));
  const [search,      setSearch]      = useState("");

  // ── Sort state ────────────────────────────────────────────────────────────
  const [sortKey, setSortKey] = useState("date");
  const [sortDir, setSortDir] = useState("desc");

  // ── Pagination ────────────────────────────────────────────────────────────
  const [page, setPage] = useState(1);

  // ── Handlers ──────────────────────────────────────────────────────────────
  function applyPreset(p) {
    setDateFrom(p.from);
    setDateTo(p.to);
    setActivePreset(p.label);
    setPage(1);
  }

  function toggleSet(setter, value) {
    setter(prev => {
      const next = new Set(prev);
      next.has(value) ? next.delete(value) : next.add(value);
      return next;
    });
    setPage(1);
  }

  function toggleAll(setter, all, currentSet) {
    setter(currentSet.size === all.length ? new Set() : new Set(all));
    setPage(1);
  }

  function handleSort(key) {
    if (sortKey === key) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortKey(key); setSortDir("desc"); }
    setPage(1);
  }

  function removeFilterChip(kind, value) {
    if (kind === "type")    toggleSet(setSelTypes,   value);
    if (kind === "class")   toggleSet(setSelClasses,  value);
    if (kind === "broker")  toggleSet(setSelBrokers,  value);
    if (kind === "search")  { setSearch(""); setPage(1); }
    if (kind === "date")    { applyPreset(PRESETS.find(p=>p.label==="All")); }
  }

  // ── Filtered + sorted data ────────────────────────────────────────────────
  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return RAW
      .filter(r =>
        r.date >= dateFrom &&
        r.date <= dateTo &&
        selTypes.has(r.type) &&
        selClasses.has(r.ac) &&
        selBrokers.has(r.broker) &&
        (!q || r.ticker.toLowerCase().includes(q) || r.name.toLowerCase().includes(q))
      )
      .sort((a, b) => {
        let av = a[sortKey], bv = b[sortKey];
        if (sortKey === "type") { av = a.type; bv = b.type; }
        if (sortKey === "ac")   { av = CLASS_INFO[a.ac]?.label ?? ""; bv = CLASS_INFO[b.ac]?.label ?? ""; }
        if (av == null) av = sortDir === "asc" ? Infinity : -Infinity;
        if (bv == null) bv = sortDir === "asc" ? Infinity : -Infinity;
        if (typeof av === "string") return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
        return sortDir === "asc" ? av - bv : bv - av;
      });
  }, [dateFrom, dateTo, selTypes, selClasses, selBrokers, search, sortKey, sortDir]);

  // ── Summary bar ───────────────────────────────────────────────────────────
  const summary = useMemo(() => {
    let buyVal = 0, sellVal = 0, income = 0, fees = 0;
    filtered.forEach(r => {
      if (r.type === "Buy")                              buyVal  += r.net;
      else if (r.type === "Sell")                        sellVal += r.net;
      else if (r.type === "Dividend" || r.type === "Coupon") income += r.net;
      else if (r.type === "Fee")                         fees    += r.net;
    });
    return { count: filtered.length, buyVal, sellVal, income, fees, net: sellVal + income - buyVal - fees };
  }, [filtered]);

  // ── Pagination slice ──────────────────────────────────────────────────────
  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage   = Math.min(page, totalPages);
  const visible    = filtered.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);

  // ── Active chips ──────────────────────────────────────────────────────────
  const chips = useMemo(() => {
    const c = [];
    const isDefaultDate = dateFrom === "2000-01-01" && dateTo === isoToday();
    if (!isDefaultDate) c.push({ kind:"date", label:`${fmtDate(dateFrom)} – ${fmtDate(dateTo)}` });
    if (selTypes.size < ALL_TYPES.length)
      ALL_TYPES.filter(t => !selTypes.has(t)).forEach(t => c.push({ kind:"type",  label:t.replace("_"," "), value:t }));
    if (selClasses.size < ALL_CLASSES.length)
      ALL_CLASSES.filter(k => !selClasses.has(k)).forEach(k => c.push({ kind:"class", label:CLASS_INFO[k]?.label, value:k }));
    if (selBrokers.size < ALL_BROKERS.length)
      ALL_BROKERS.filter(b => !selBrokers.has(b)).forEach(b => c.push({ kind:"broker",label:b, value:b }));
    if (search) c.push({ kind:"search", label:`"${search}"` });
    return c;
  }, [dateFrom, dateTo, selTypes, selClasses, selBrokers, search]);

  // ── Styles ────────────────────────────────────────────────────────────────
  const card  = { background:"var(--gray_900_01)", border:"1px solid var(--gray_900)", borderRadius:10 };
  const th = (right=false) => ({
    padding:"10px 14px", textAlign:right?"right":"left",
    fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px",
    whiteSpace:"nowrap", userSelect:"none",
  });
  const td = (right=false, mono=false, color="var(--gray_400)") => ({
    padding:"10px 14px", textAlign:right?"right":"left",
    fontSize:mono?13:12, fontFamily:mono?"monospace":"inherit", color,
  });
  const sortIcon = (key) => {
    if (sortKey !== key) return <span style={{ opacity:0.2, marginLeft:4 }}>↕</span>;
    return <span style={{ marginLeft:4, color:"var(--indigo_a700)" }}>{sortDir==="asc"?"↑":"↓"}</span>;
  };
  const thBtn = (key, right=false, label) => (
    <th style={{ ...th(right), cursor:"pointer" }} onClick={() => handleSort(key)}>
      {label}{sortIcon(key)}
    </th>
  );
  const chipStyle = { display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:20,
    fontSize:11, background:"rgba(43,54,217,0.12)", color:"var(--indigo_a700)", border:"1px solid rgba(43,54,217,0.25)" };

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Helmet>
        <title>Transactions – Tail Risk Global</title>
        <meta name="description" content="View and filter past portfolio transactions." />
      </Helmet>

      <div className="flex flex-col min-h-screen bg-gray-900_02">
        <div className="w-full"><Navbar /></div>

        <div className="flex flex-1" style={{ borderTop:"1px solid var(--gray_900)" }}>
          <DashboardMenuBar activePage="Transactions" />

          <main style={{ flex:1, padding:"36px 40px", overflowX:"hidden" }}>

            {/* ── Page header ── */}
            <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:28 }}>
              <div>
                <div style={{ fontSize:11, color:"var(--gray_500)", letterSpacing:"1.5px", textTransform:"uppercase", marginBottom:4 }}>Portfolio</div>
                <div style={{ fontSize:26, fontWeight:600, color:"var(--white_a700)", letterSpacing:"0.3px" }}>Transactions</div>
              </div>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <div style={{ padding:"5px 10px", borderRadius:4, fontSize:10, fontWeight:700, letterSpacing:"1px", background:"rgba(43,54,217,0.15)", color:"var(--indigo_a700)" }}>
                  STATIC PROTOTYPE
                </div>
                <button
                  onClick={() => exportCSV(filtered)}
                  style={{ padding:"8px 16px", fontSize:12, fontWeight:600, borderRadius:6, cursor:"pointer",
                    border:"1px solid var(--gray_900)", background:"var(--gray_900_01)", color:"var(--gray_400)", letterSpacing:"0.3px" }}>
                  Export CSV ↓
                </button>
              </div>
            </div>

            {/* ── Filters ── */}
            <div style={{ ...card, padding:"18px 20px", marginBottom:16 }}>
              <div style={{ display:"flex", gap:24, flexWrap:"wrap", alignItems:"flex-start" }}>

                {/* Date range */}
                <div>
                  <div style={{ fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8 }}>Date Range</div>
                  <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                    {PRESETS.map(p => (
                      <button key={p.label} onClick={() => applyPreset(p)} style={{
                        padding:"5px 11px", fontSize:11, fontWeight:600, borderRadius:5, cursor:"pointer",
                        border:"1px solid var(--gray_900)",
                        background: activePreset===p.label ? "var(--indigo_a700)" : "var(--gray_900_02)",
                        color: activePreset===p.label ? "#fff" : "var(--gray_500)",
                        transition:"all 0.15s",
                      }}>{p.label}</button>
                    ))}
                    <span style={{ fontSize:11, color:"var(--gray_500)", margin:"0 4px" }}>or</span>
                    <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setActivePreset(""); setPage(1); }}
                      style={{ padding:"4px 8px", fontSize:11, background:"var(--gray_900_02)", border:"1px solid var(--gray_900)", borderRadius:5, color:"var(--white_a700)", outline:"none", colorScheme:"dark" }} />
                    <span style={{ fontSize:11, color:"var(--gray_500)" }}>–</span>
                    <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setActivePreset(""); setPage(1); }}
                      style={{ padding:"4px 8px", fontSize:11, background:"var(--gray_900_02)", border:"1px solid var(--gray_900)", borderRadius:5, color:"var(--white_a700)", outline:"none", colorScheme:"dark" }} />
                  </div>
                </div>

                {/* Divider */}
                <div style={{ width:1, background:"var(--gray_900)", alignSelf:"stretch" }} />

                {/* Type filter */}
                <div>
                  <div style={{ fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8, display:"flex", gap:8, alignItems:"center" }}>
                    Type
                    <span onClick={() => toggleAll(setSelTypes, ALL_TYPES, selTypes)} style={{ fontSize:10, color:"var(--indigo_a700)", cursor:"pointer", fontWeight:600, letterSpacing:"normal" }}>
                      {selTypes.size === ALL_TYPES.length ? "None" : "All"}
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                    {ALL_TYPES.map(t => {
                      const info = TYPE_INFO[t] ?? {};
                      const on   = selTypes.has(t);
                      return (
                        <button key={t} onClick={() => toggleSet(setSelTypes, t)} style={{
                          padding:"4px 10px", fontSize:11, fontWeight:600, borderRadius:5, cursor:"pointer",
                          border:`1px solid ${on ? info.color ?? "var(--gray_900)" : "var(--gray_900)"}`,
                          background: on ? info.bg ?? "rgba(255,255,255,0.04)" : "transparent",
                          color: on ? info.color ?? "var(--gray_400)" : "var(--gray_500)",
                          transition:"all 0.15s",
                        }}>{t.replace("_"," ")}</button>
                      );
                    })}
                  </div>
                </div>

                {/* Asset class filter */}
                <div>
                  <div style={{ fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8, display:"flex", gap:8, alignItems:"center" }}>
                    Asset Class
                    <span onClick={() => toggleAll(setSelClasses, ALL_CLASSES, selClasses)} style={{ fontSize:10, color:"var(--indigo_a700)", cursor:"pointer", fontWeight:600, letterSpacing:"normal" }}>
                      {selClasses.size === ALL_CLASSES.length ? "None" : "All"}
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                    {ALL_CLASSES.map(k => {
                      const info = CLASS_INFO[k];
                      const on   = selClasses.has(k);
                      return (
                        <button key={k} onClick={() => toggleSet(setSelClasses, k)} style={{
                          padding:"4px 10px", fontSize:11, fontWeight:600, borderRadius:5, cursor:"pointer",
                          border:`1px solid ${on ? info.color : "var(--gray_900)"}`,
                          background: on ? `${info.color}22` : "transparent",
                          color: on ? info.color : "var(--gray_500)",
                          transition:"all 0.15s",
                        }}>{info.label}</button>
                      );
                    })}
                  </div>
                </div>

                {/* Broker filter */}
                <div>
                  <div style={{ fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8, display:"flex", gap:8, alignItems:"center" }}>
                    Broker
                    <span onClick={() => toggleAll(setSelBrokers, ALL_BROKERS, selBrokers)} style={{ fontSize:10, color:"var(--indigo_a700)", cursor:"pointer", fontWeight:600, letterSpacing:"normal" }}>
                      {selBrokers.size === ALL_BROKERS.length ? "None" : "All"}
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                    {ALL_BROKERS.map(b => {
                      const on = selBrokers.has(b);
                      return (
                        <button key={b} onClick={() => toggleSet(setSelBrokers, b)} style={{
                          padding:"4px 10px", fontSize:11, fontWeight:600, borderRadius:5, cursor:"pointer",
                          border:`1px solid ${on ? "#06b6d4" : "var(--gray_900)"}`,
                          background: on ? "rgba(6,182,212,0.10)" : "transparent",
                          color: on ? "#06b6d4" : "var(--gray_500)",
                          transition:"all 0.15s",
                        }}>{b}</button>
                      );
                    })}
                  </div>
                </div>

                {/* Search */}
                <div style={{ marginLeft:"auto" }}>
                  <div style={{ fontSize:10, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8 }}>Search</div>
                  <input
                    type="text" placeholder="Ticker or name…" value={search}
                    onChange={e => { setSearch(e.target.value); setPage(1); }}
                    style={{ padding:"6px 12px", fontSize:12, width:180,
                      background:"var(--gray_900_02)", border:"1px solid var(--gray_900)",
                      borderRadius:6, color:"var(--white_a700)", outline:"none" }} />
                </div>
              </div>
            </div>

            {/* ── Active filter chips ── */}
            {chips.length > 0 && (
              <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:14, alignItems:"center" }}>
                <span style={{ fontSize:11, color:"var(--gray_500)" }}>Active filters:</span>
                {chips.map((c, i) => (
                  <span key={i} style={chipStyle}>
                    {c.label}
                    <span onClick={() => removeFilterChip(c.kind, c.value)} style={{ cursor:"pointer", fontSize:12, lineHeight:1, opacity:0.7 }}>✕</span>
                  </span>
                ))}
                <span onClick={() => {
                  applyPreset(PRESETS.find(p=>p.label==="All"));
                  setSelTypes(new Set(ALL_TYPES));
                  setSelClasses(new Set(ALL_CLASSES));
                  setSelBrokers(new Set(ALL_BROKERS));
                  setSearch("");
                }} style={{ fontSize:11, color:"var(--gray_500)", cursor:"pointer", textDecoration:"underline", marginLeft:4 }}>
                  Clear all
                </span>
              </div>
            )}

            {/* ── Summary bar ── */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:12, marginBottom:20, animation:"fadeSlideUp 0.4s ease both" }}>
              {[
                { label:"Transactions",  val: summary.count.toString(), color:"var(--white_a700)", accent:"var(--indigo_a700)" },
                { label:"Total Bought",  val: fmtMoney(summary.buyVal),  color:"#f59e0b",           accent:"#f59e0b" },
                { label:"Total Sold",    val: fmtMoney(summary.sellVal), color:"#04ff1d",           accent:"#04ff1d" },
                { label:"Income",        val: fmtMoney(summary.income),  color:"#06b6d4",           accent:"#06b6d4" },
                { label:"Net Cash Flow", val: (summary.net >= 0 ? "+" : "") + fmtMoney(summary.net),
                  color: summary.net >= 0 ? "#04ff1d" : "#ff2e2e", accent: summary.net >= 0 ? "#04ff1d" : "#ff2e2e" },
              ].map((s, i) => (
                <div key={i} style={{ ...card, padding:"14px 16px", position:"relative", animation:`fadeSlideUp 0.35s ${i*0.05}s ease both` }}>
                  <div style={{ position:"absolute", top:0, left:0, right:0, height:2, borderRadius:"10px 10px 0 0", background:s.accent }} />
                  <div style={{ fontSize:9, color:"var(--gray_500)", textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:7 }}>{s.label}</div>
                  <div style={{ fontSize:18, fontWeight:700, fontFamily:"monospace", color:s.color }}>{s.val}</div>
                </div>
              ))}
            </div>

            {/* ── Transaction table ── */}
            <div style={{ ...card, overflow:"hidden" }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ borderBottom:"1px solid var(--gray_900)" }}>
                      {thBtn("date",  false, "Date")}
                      {thBtn("ticker",false, "Ticker")}
                      <th style={th()}>Name</th>
                      {thBtn("ac",    false, "Class")}
                      {thBtn("type",  false, "Type")}
                      {thBtn("qty",   true,  "Quantity")}
                      {thBtn("price", true,  "Price")}
                      {thBtn("gross", true,  "Gross Value")}
                      {thBtn("net",   true,  "Net Value")}
                      <th style={th()}>CCY</th>
                      <th style={th()}>Broker</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visible.length === 0 ? (
                      <tr>
                        <td colSpan={11} style={{ padding:"48px", textAlign:"center", fontSize:13, color:"var(--gray_500)" }}>
                          No transactions match the current filters.
                        </td>
                      </tr>
                    ) : visible.map((r, i) => {
                      const tInfo = TYPE_INFO[r.type] ?? {};
                      const cInfo = CLASS_INFO[r.ac]  ?? {};
                      return (
                        <tr key={r.id} style={{ borderBottom:"1px solid rgba(255,255,255,0.04)", background:i%2===0?"transparent":"rgba(255,255,255,0.01)" }}>
                          <td style={td(false, true, "var(--gray_400)")}>{fmtDate(r.date)}</td>
                          <td style={{ padding:"10px 14px" }}>
                            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                              <div style={{ width:6, height:6, borderRadius:2, background:cInfo.color??"#888", flexShrink:0 }} />
                              <span style={{ fontSize:13, fontWeight:700, fontFamily:"monospace", color:"var(--white_a700)" }}>{r.ticker}</span>
                            </div>
                          </td>
                          <td style={{ ...td(), maxWidth:200, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{r.name}</td>
                          <td style={{ padding:"10px 14px" }}>
                            <span style={{ fontSize:10, padding:"2px 7px", borderRadius:4, fontWeight:600, background:`${cInfo.color}22`, color:cInfo.color }}>
                              {cInfo.label ?? r.ac}
                            </span>
                          </td>
                          <td style={{ padding:"10px 14px" }}>
                            <span style={{ fontSize:11, padding:"2px 9px", borderRadius:4, fontWeight:600, background:tInfo.bg??"transparent", color:tInfo.color??"var(--gray_400)" }}>
                              {r.type.replace("_"," ")}
                            </span>
                          </td>
                          <td style={td(true, true, "var(--gray_400)")}>{r.qty != null ? fmtNum(r.qty, 0) : "—"}</td>
                          <td style={td(true, true, "var(--gray_400)")}>{r.price != null ? fmtMoney(r.price) : "—"}</td>
                          <td style={td(true, true, "var(--white_a700)")}>{fmtMoney(r.gross)}</td>
                          <td style={td(true, true, "var(--white_a700)")}>{fmtMoney(r.net)}</td>
                          <td style={td(false, false, "var(--gray_500)")}>{r.ccy}</td>
                          <td style={td(false, false, "var(--gray_500)")}>{r.broker}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* ── Pagination ── */}
              {totalPages > 1 && (
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 16px", borderTop:"1px solid var(--gray_900)" }}>
                  <span style={{ fontSize:11, color:"var(--gray_500)" }}>
                    Showing {((safePage-1)*PAGE_SIZE)+1}–{Math.min(safePage*PAGE_SIZE, filtered.length)} of {filtered.length}
                  </span>
                  <div style={{ display:"flex", gap:4 }}>
                    <button onClick={() => setPage(1)} disabled={safePage===1} style={pgBtn(safePage===1)}>«</button>
                    <button onClick={() => setPage(p=>Math.max(1,p-1))} disabled={safePage===1} style={pgBtn(safePage===1)}>‹</button>
                    {Array.from({ length: totalPages }, (_, i) => i+1)
                      .filter(n => Math.abs(n - safePage) <= 2)
                      .map(n => (
                        <button key={n} onClick={() => setPage(n)} style={pgBtn(false, n===safePage)}>{n}</button>
                      ))}
                    <button onClick={() => setPage(p=>Math.min(totalPages,p+1))} disabled={safePage===totalPages} style={pgBtn(safePage===totalPages)}>›</button>
                    <button onClick={() => setPage(totalPages)} disabled={safePage===totalPages} style={pgBtn(safePage===totalPages)}>»</button>
                  </div>
                </div>
              )}
            </div>

          </main>
        </div>
      </div>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity:0; transform:translateY(16px); }
          to   { opacity:1; transform:translateY(0); }
        }
        input[type="date"]::-webkit-calendar-picker-indicator { filter: invert(0.5); cursor:pointer; }
      `}</style>
    </>
  );
}

function pgBtn(disabled, active=false) {
  return {
    padding:"5px 10px", fontSize:12, fontWeight:600, borderRadius:5, cursor:disabled?"default":"pointer",
    border:`1px solid ${active?"var(--indigo_a700)":"var(--gray_900)"}`,
    background:active?"var(--indigo_a700)":disabled?"transparent":"var(--gray_900_02)",
    color:active?"#fff":disabled?"var(--gray_500)":"var(--gray_400)",
    opacity:disabled?0.4:1, transition:"all 0.15s",
  };
}
